import React, { useState } from 'react'
import { TbArrowBackUpDouble } from 'react-icons/tb'
import { motion } from 'framer-motion'
import './style.css'
import CodeHighlight from '../../components/CodeHighlight';
import { loadCode1, loadCode2, loadCode3 } from './code';
import { IoRefresh } from 'react-icons/io5';
import { installFramer } from '../Hover/code';

function Load() {
  const [key1, setKey1] = useState(0);
  const [key2, setKey2] = useState(0);
  const [key3, setKey3] = useState(0);

  const refreshAnimation = () => {
    setKey1(prevKey => prevKey + 1); // Change the key to refresh the animation
  };

  const refreshAnimation2 = () => {
    setKey2(prevKey => prevKey + 1); // Change the key to refresh the animation
  };

  const refreshAnimation3 = () => {
    setKey3(prevKey => prevKey + 1); // Change the key to refresh the animation
  };

  const container = {
    hidden: { opacity: 1, scale: 0 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  return (
    <div className='w-screen bg-[#1e1e1e] text-white overflow-auto flex items-center justify-center h-screen'>
      <div className='w-full max-w-[1200px] h-screen no-scrollbar overflow-auto py-6 px-2'>
        <div className='flex flex-col gap-4'>
          <div className='flex flex-col gap-4'>
            <a href='/' className='text-2xl md:text-3xl flex items-center gap-2 text-neutral-200'>
              <TbArrowBackUpDouble />
              Load Animation</a>
            <motion.span
              initial={{ opacity: 0, x: -200 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className='text-neutral-300 text-justify'>Load Animation is an animation component that is activated when an element enters the user's viewport (in view). This animation aims to provide a dynamic interactive experience, where elements on a web page will appear or animate only when they are viewed by the user. This component is very useful for focusing user attention on important elements and optimizing page performance by delaying animations until the elements are really needed. *like this description*
            </motion.span>
          </div>
          
          <CodeHighlight
            code={installFramer}
            title="terminal"
            language="css"
          />

          <span>Example using variants : </span>
          <CodeHighlight
            code={loadCode1}
            title="example.js"
            language="css"
          />
          <span>Result : </span>
          <div className='w-full py-2 min-h-[100px] relative rounded-lg flex items-center justify-center bg-neutral-700'>
            <div className='absolute left-2 top-2'>
              <button onClick={refreshAnimation} className='bg-slate-400 text-2xl p-1 rounded-lg'><IoRefresh /></button>
            </div>
            <motion.ul
              key={key1}
              className="container"
              variants={container}
              initial="hidden"
              animate="visible"
            >
              {[0, 1, 2, 3].map((index) => (
                <motion.li key={index} className="item" variants={item} />
              ))}
            </motion.ul>
          </div>

          <span className='text-neutral-300 text-justify'>In the example above, we have a list of four items that will be animated when the user scrolls to them. The container and item variants are defined in the code, and the initial and animate properties are set to "hidden" and "visible" respectively. When the user scrolls to the list, the "visible" property is triggered, causing the list to animate.</span>


          <span>Example using whileInView : </span>
          <CodeHighlight
            code={loadCode2}
            title="example.js"
            language="css"
          />

          <span>Result : </span>
          <div className='w-full py-2 min-h-[100px] relative rounded-lg overflow-hidden flex flex-col gap-2 items-center justify-center bg-neutral-700'>
            <div className='absolute left-2 top-2'>
              <button onClick={refreshAnimation2} className='bg-slate-400 text-2xl p-1 rounded-lg'><IoRefresh /></button>
            </div>
            <motion.div
              key={`${key2}-1`}
              initial={{ opacity: 0, x: 200 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className='w-[150px] h-[80px] bg-green-500 rounded-lg'></motion.div>
            <motion.div
              key={`${key2}-2`}
              initial={{ opacity: 0, x: -200 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className='w-[150px] h-[80px] bg-blue-500 rounded-lg'></motion.div>

            <div className='flex items-center gap-2 w-full justify-center'>
              <motion.div
                key={`${key2}-4`}
                initial={{ scale: 0.5, x: -100, translateY : 100 }}
                whileInView={{ scale: 1, x: 0 , translateY : 0}}
                transition={{ duration: 0.5 }}
                className='w-[150px] h-[80px] bg-red-500 rounded-lg'></motion.div>
              <motion.div
                key={`${key2}-5`}
                initial={{ scale: 0.5, x: 100, y : 100 }}
                whileInView={{ scale: 1, x: 0 , y : 0}}
                transition={{ duration: 0.5 }}
                className='w-[150px] h-[80px] bg-red-500 rounded-lg'></motion.div>
            </div>
            <motion.div
              key={`${key2}-3`}
              initial={{ scale: 0.5, rotate: -200 }}
              whileInView={{ scale: 1, rotate: 0 }}
              transition={{ duration: 0.5 }}
              className='w-[150px] h-[80px] bg-red-500 rounded-lg'></motion.div>
          </div>

          <span>whileInView is a prop used in Framer Motion to trigger an animation only when an element enters the user's viewport. This provides a more dynamic and interactive experience by ensuring that animations only occur when elements are visible on screen, saving resources and improving page performance.</span>

          <span>Example using whileInView : </span>
          <CodeHighlight
            code={loadCode3}
            title="example.js"
            language="css"
          />

          <span>Result : </span>
          <div className='w-full py-2 min-h-[100px] relative rounded-lg overflow-hidden flex flex-col gap-2 items-center justify-center bg-neutral-700'>
            <div className='absolute left-2 top-2'>
              <button onClick={refreshAnimation3} className='bg-slate-400 text-2xl p-1 rounded-lg'><IoRefresh /></button>
            </div>
            <motion.div
              key={`${key3}-9`}
              viewport={{ once : true }}
              initial={{ opacity: 0, x: 200 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className='w-[150px] h-[80px] bg-green-500 rounded-lg'></motion.div>
           
          </div>

          <span>{'viewport={{ once: true }}'} is a configuration option used in Framer Motion to control the animation behavior that is triggered when an element enters the viewport (visible area on the screen). When the once property is set to true, the animation will run only once—when the element is first visible in the viewport. Once the animation is complete, the element will not animate again, even if the user scrolls or changes the position of the page so that the element exits and returns to the viewport.</span>
        </div>
      </div>
    </div>
  )
}

export default Load
